import { render } from "./JobType.vue?vue&type=template&id=15c164ad"
import script from "./JobType.vue?vue&type=script&lang=ts"
export * from "./JobType.vue?vue&type=script&lang=ts"
script.render = render

export default script